import { createContext } from 'react';
import Router from "Router";
import Header from 'Container/home/header';
import { useLocation } from "react-router-dom";

// 콘솔 제거
if (process.env.REACT_APP_CONSOLE_LOG === "N") {
  const console = window.console || {};
  console.log = function no_console() {};
  console.warn = function no_console() {};
  console.error = function () {};
}

export const UserContext = createContext(null);

function App () {
  const { pathname } = useLocation();

  // consider '/stock', '/stock/' and '/stock?query' as stock page
  const isStockPage = pathname.startsWith('/stock');

  return (
    <UserContext.Provider value={null}>
      { pathname === '/' && <Header /> }
      <section id="container">
        <Router />
      </section>
    </UserContext.Provider>
  );
}

export default App;
